import { useTranslations } from 'next-intl'
import { Box, Grid, Text, Button } from '@chakra-ui/react'
import NextLink from 'next/link'

interface FacilityMobileCardProps {
  facilitiesId: string
  facilitiesName: string
  availabilityText: string
  availabilityTextColor: string
}

export function FacilityListMobileCard({
  facilitiesId,
  facilitiesName,
  availabilityText,
  availabilityTextColor,
}: FacilityMobileCardProps) {
  const t = useTranslations()

  return (
    <Box
      borderRadius={'base'}
      border="1px"
      borderColor="gray.230"
      p={4}
      mb={4}
      boxShadow={'0px 2px 4px rgba(0, 0, 0, 0.06)'}
    >
      <Grid templateColumns="repeat(2, minmax(0, 1fr))" mb={3}>
        <Text size={'xs'}>{t('facilities-list.facility')}</Text>
        <Text size={'xs'} textAlign={'right'}>
          {facilitiesName}
        </Text>
      </Grid>
      <Grid templateColumns="repeat(2, minmax(0, 1fr))" mb={3}>
        <Text size={'xs'}>{t('facilities-list.availability')}</Text>
        <Text size={'xs'} textAlign={'right'} color={availabilityTextColor}>
          {availabilityText}
        </Text>
      </Grid>
      <NextLink href={`facilities/${facilitiesId}`} passHref>
        <Button mt={2} w={'full'} as={'a'} variant="black" fontWeight={400}>
          {t('facilities-list.view-farm')}
        </Button>
      </NextLink>
    </Box>
  )
}
